module.exports = __webpack_public_path__ + "img/hexin-1.458ca39a.jpg";